import { UserAccessService } from '@/features/user-access/user-access.service';
import { useQuery } from '@tanstack/react-query';

const useProfile = () => {
  const { data } = useQuery({
    queryKey: ['profile'],
    queryFn: UserAccessService.getProfile,
    select: data => data?.data,
  });

  return { data };
};

export { useProfile };
